/**
 * Hex coordinate types and constants — shared between server and client.
 * DO NOT EDIT in server/src/shared/common/ or phaser/src/shared/common/
 * Edit the canonical copy in shared/ and run: node scripts/sync-shared.js
 */

export interface HexCoord {
  q: number;
  r: number;
}

// Direction vectors for hex neighbors (pointy-top)
export const HEX_DIRECTIONS: HexCoord[] = [
  { q: +1, r: 0 },
  { q: +1, r: -1 },
  { q: 0, r: -1 },
  { q: -1, r: 0 },
  { q: -1, r: +1 },
  { q: 0, r: +1 },
];
